:host {
  display: block;
  box-sizing: border-box;
  content-visibility: auto;
  contain-intrinsic-size: auto var(--dimension-size-800);
  -webkit-user-select: none;
  user-select: none;
}

:host(.message-host--group-middle),
:host(.message-host--group-last) {
  margin-block-start: calc(var(--dimension-space-050) - var(--dimension-space-300));
}

.message {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: end;
  gap: 0;
  width: 100%;
  box-sizing: border-box;
}

.message--outgoing {
  grid-template-columns: minmax(0, 1fr) auto;
}

.message__header:empty,
.message__footer:empty,
.message__metadata-actions:empty,
.message__actions:empty {
  display: none;
}

.message__actions:not(:empty) {
  margin-inline-start: var(--dimension-space-075);
}

.message__body {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: var(--dimension-space-050);
}

.message--incoming .message__body {
  width: 100%;
}

.message--outgoing .message__body {
  align-items: flex-end;
}

.message--outgoing .message__header {
  display: none;
}

.message--system .message__body {
  align-items: center;
}

.message__header,
.message__footer,
.message__metadata-actions,
.message__actions {
  display: flex;
  align-items: center;
  gap: var(--dimension-space-050);
}

@media (hover: hover) and (pointer: fine) {
  .message--metadata-hover .message__footer {
    opacity: 0;
    pointer-events: none;
    transition: opacity var(--effect-motion-short-2);
  }

  .message--metadata-hover:hover .message__footer,
  .message--metadata-hover:focus-within .message__footer {
    opacity: 1;
    pointer-events: auto;
  }
}

@media (prefers-reduced-motion: reduce) {
  .message--metadata-hover .message__footer {
    transition: none;
  }
}

.message__content {
  width: 100%;
  min-width: 0;
  -webkit-user-select: text;
  user-select: text;
}

.message--outgoing .message__content {
  display: flex;
  justify-content: flex-end;
}

.message__footer time {
  display: inline-flex;
}

.message--group-middle .message__header,
.message--group-last .message__header {
  display: none;
}

.message--group-first .message__footer,
.message--group-middle .message__footer {
  display: none;
}
